import React, { FC } from 'react';
import { LinkButton } from '@domain-group/fe-co-button';
import { EmailIconSmall } from '@domain-group/fe-co-icon';
import * as gtag from 'src/lib/gtag';
import * as commonLandingStyles from './landingpage.styles';
import * as styles from './explore.styles';
import * as illustrations from './illustrations/all';

interface ExploreCardProps {
  title: string;
  content: string;
  target: string;
  image: React.ReactNode;
}

const ExploreCard: FC<ExploreCardProps> = ({
  title,
  content,
  target,
  image,
}) => (
  <li css={styles.exploreCard}>
    <a css={styles.exploreCardLink} href={target}>
      <h3>{title}</h3>
      <p>{content}</p>
      <div className="flex-space" />
      <div css={styles.exploreCardImage}>{image}</div>
    </a>
  </li>
);

const Explore: FC = () => (
  <div css={commonLandingStyles.sectionContainer}>
    <h2 css={commonLandingStyles.sectionHeader}>Explore Domain API Packages</h2>
    <ol css={styles.exploreList}>
      <ExploreCard
        title="Address Suggestions"
        target="/docs/latest/apis/pkg_address_suggestion"
        content="Search for valid property addresses and properties."
        image={<illustrations.AddressSuggestion />}
      />
      <ExploreCard
        title="Agents & Listings"
        target="/docs/latest/apis/pkg_agents_listings"
        content="Access data on agents and listings directly from Domain."
        image={<illustrations.Agent />}
      />
      <ExploreCard
        title="Listing Management"
        target="/docs/latest/apis/pkg_listing_management"
        content="View, create, and update listings securely. Simplify lead management with real-time inquiries and stats."
        image={<illustrations.Listing />}
      />
      <ExploreCard
        title="Price Estimation"
        target="/docs/latest/apis/pkg_price_estimation"
        content="Retrieve the current price estimate for any property."
        image={<illustrations.PriceEstimation />}
      />
      <ExploreCard
        title="Properties & Locations"
        target="/docs/latest/apis/pkg_properties_locations"
        content="Explore auction results and property datasets. Access market performance and demographic stats."
        image={<illustrations.Home />}
      />
      <ExploreCard
        title="Property Enrichment"
        target="/docs/latest/apis/pkg_property_enrichment"
        content="Enhance your property data with additional details."
        image={<illustrations.PropertyEnrichment />}
      />
      <ExploreCard
        title="Property Package"
        target="/docs/latest/apis/pkg_property"
        content="Access a comprehensive package of property data."
        image={<illustrations.PropertyPackage />}
      />
      <ExploreCard
        title="PropertyRadar"
        target="/docs/latest/apis/pkg_propertyradar"
        content="Manage property portfolios with PropertyRadar."
        image={<illustrations.PropertyRadar />}
      />
      <ExploreCard
        title="Schools Data"
        target="/docs/latest/apis/pkg_schools_data"
        content="Retrieve detailed information on schools."
        image={<illustrations.School />}
      />
      <ExploreCard
        title="Webhooks"
        target="/docs/latest/apis/pkg_webhooks"
        content="Receive instant notifications when data updates in the Domain system."
        image={<illustrations.Webhooks />}
      />

      <li css={styles.exploreCard}>
        <div>
          <h3>Need something else?</h3>
          <p>Contact our team for custom data solutions.</p>
        </div>
        <div className="flex-space" />
        <LinkButton
          icon={<EmailIconSmall />}
          css={styles.exploreContactButton}
          appearance="outline"
          href="/contact"
          onClick={() =>
            gtag.event({
              category: 'landing-page',
              action: 'click',
              label: 'contact-us',
            })
          }
        >
          Contact&nbsp;Us
        </LinkButton>
      </li>
    </ol>
  </div>
);

export default Explore;
